import { render, staticRenderFns } from "./RepairStats.vue?vue&type=template&id=b81efe44&scoped=true"
import script from "./RepairStats.vue?vue&type=script&lang=js"
export * from "./RepairStats.vue?vue&type=script&lang=js"
import style0 from "./RepairStats.vue?vue&type=style&index=0&id=b81efe44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81efe44",
  null
  
)

export default component.exports